import { api } from '../../shared/lib/api';

export interface Periodo {
  inicio: string;
  fim: string;
}

export interface KpisResponse extends Periodo {
  vendas: number;
  receita: number;
  ticket_medio: number;
  itens: number;
}

export interface VendasPorDiaRow {
  dia: string;
  qtd_vendas: number;
  subtotal: number;
  desconto: number;
  total: number;
  ticket_medio: number;
}

export interface VendasPorHoraRow {
  hora: string;
  qtd_vendas: number;
  total: number;
}

export interface ProdutoTopRow {
  produto_id: string;
  produto_nome: string;
  quantidade_total: number;
  receita_total: number;
  vendas: number;
}

export interface PagamentoPorFormaRow {
  forma: string;
  total: number;
  qtd: number;
}

export interface CategoriaVendaRow {
  categoria_id: string;
  categoria_nome: string;
  cor: string;
  receita: number;
  quantidade: number;
}

export interface OperadorPerformanceRow {
  operador_id: string;
  nome: string;
  email: string;
  vendas: number;
  receita: number;
  ticket_medio: number;
}

export interface VendaDetalhadaRow {
  id: string;
  numero: number;
  criado_em: string;
  total: number | string;
  subtotal: number | string;
  desconto: number | string;
  status: 'paga' | 'cancelada';
  operador: { nome: string } | null;
  itens: Array<{ quantidade: number | string; produto_nome: string }>;
  pagamentos: Array<{ forma: string; valor: number | string }>;
}

interface Period {
  inicio?: string;
  fim?: string;
}

function qs(p: object): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(p as Record<string, unknown>)) {
    if (v != null && v !== '') out[k] = v;
  }
  return out;
}

export const relatoriosApi = {
  kpis: (p: Period = {}) => api.get<KpisResponse>('relatorios/kpis', qs(p)),
  vendasPorDia: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: VendasPorDiaRow[] }>('relatorios/vendas-por-dia', qs(p)),
  vendasPorHora: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: VendasPorHoraRow[] }>('relatorios/vendas-por-hora', qs(p)),
  topProdutos: (p: Period & { limit?: number } = {}) =>
    api.get<{ periodo: Periodo; rows: ProdutoTopRow[] }>('relatorios/top-produtos', qs(p)),
  pagamentosPorForma: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: PagamentoPorFormaRow[] }>(
      'relatorios/pagamentos-por-forma',
      qs(p),
    ),
  vendasPorCategoria: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: CategoriaVendaRow[] }>(
      'relatorios/vendas-por-categoria',
      qs(p),
    ),
  operadorPerformance: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: OperadorPerformanceRow[] }>(
      'relatorios/operador-performance',
      qs(p),
    ),
  vendasDetalhadas: (p: Period = {}) =>
    api.get<{ periodo: Periodo; rows: VendaDetalhadaRow[] }>(
      'relatorios/vendas-detalhadas',
      qs(p),
    ),
};
